import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { TextChatMessage } from '../../types';
import Message from './Message';
import { CallRequestType } from '../../customer-call-sdk';

const StyledTextChatBody = styled.div`
    overflow: hidden;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    .chat-body-gap {
        flex: 1;
    }
    .chat-body-container {
        padding: 24px;
        height: auto;
        display: flex;
        flex-direction: column;
    }
`;

interface TextChatBodyProps {
    messages: TextChatMessage[];
    callRequestType: CallRequestType;
    className?: string;
}
/**
 * Text Chat Body component
 */
const TextChatBody: React.FC<TextChatBodyProps> = ({ className, messages, callRequestType }) => {
    const textChatBodyRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (textChatBodyRef.current) {
            textChatBodyRef.current.scrollTop = textChatBodyRef.current.scrollHeight;
        }
    }, [messages]);
    return (
        <StyledTextChatBody className={cx(className)} ref={textChatBodyRef}>
            <div className="chat-body-gap" />
            <div className="chat-body-container">
                {messages.map((message, index) => {
                    const isContinuousMessage =
                        index === 0 ? false : messages[index - 1].type === message.type;
                    return (
                        <Message
                            isContinuousMessage={isContinuousMessage}
                            message={message}
                            key={message.id}
                            callRequestType={callRequestType}
                        />
                    );
                })}
            </div>
        </StyledTextChatBody>
    );
};

export default TextChatBody;
